/**
 * Triggers a browser file download from a Blob.
 */
export const triggerBlobDownload = (blob, filename) => {
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(url)
}

/**
 * Extracts filename from a Content-Disposition header value.
 * Works with both axios (response.headers['content-disposition'])
 * and fetch (response.headers.get('content-disposition')).
 */
export const extractFilenameFromHeader = (contentDisposition, fallback = 'download') => {
  if (contentDisposition) {
    const quoted = contentDisposition.match(/filename="([^"]+)"/)
    if (quoted) return quoted[1]
    const unquoted = contentDisposition.match(/filename=([^;\s]+)/)
    if (unquoted) return unquoted[1].trim()
  }
  return fallback
}
